<template>
<AdminPanelEGiftsPackageSellingHistoryEdit />
</template>

<script>
import AdminPanelEGiftsPackageSellingHistoryEdit from '../components/AdminPanelEGiftsPackageSellingHistoryEdit.vue'
export default {
    data: () => ({}),
    components: {
        AdminPanelEGiftsPackageSellingHistoryEdit
    },
    methods: {},
    mounted() {}
}
</script>